module.exports = __webpack_public_path__ + "img/background.edaee4e.png";